import React from "react";
import { Button, Modal } from "semantic-ui-react";
import DeleteAxios from "../../axiosComponent/delete";

function DeleteBillingPartyBranchModal(props) {
  return (
    <Modal onClose={props.CloseModal} open={props.deleteOpen} size="mini">
      <Modal.Header>{props.notification||"Confirm Delete"}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <p>{props.message || "Are you sure want to delete ?"}</p>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button
          size="mini"
          type="button"
          onClick={props.CloseModal}
        >cancel</Button>
        <Button type="button" size="mini" color="blue" onClick={()=>props.currentObject ? props.handleDelete(props.currentObject) : props.handleDelete() }>Delete</Button>
      </Modal.Actions>
    </Modal>
  );
}

export default DeleteBillingPartyBranchModal;
